
export const SupportPage = () => {
  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6">Help & Support</h1>
      <div className="text-muted-foreground">
        Get help and support for using the platform.
      </div>
    </div>
  );
};
